/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */

export function debounce(func, delay = 1000) {
  let timer
  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.call(this, ...args)
    }, delay)
  }
}

// JSON 转 Base64
export function jsonToBase64(jsonData) {
  // 将 JSON 对象转换为字符串
  const jsonString =
    typeof jsonData === 'string' ? jsonData : JSON.stringify(jsonData)

  // 转换为 Base64 编码
  // 注意：btoa() 方法处理的是二进制数据，因此需要先进行 UTF-8 编码转换
  const encoded = btoa(unescape(encodeURIComponent(jsonString)))
  return encoded
}

// 获取Cookie
export function getCookie(name) {
  console.log('document.cookie', document.cookie)
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

/**
 * 算法功能例图
 * @param {*} commonPath 子图路径，例：/public/new-image/body_keypoint/case3
 * @param {*} oriImgName 主图名称，例：ori 或 ori_bbox
 * @param {*} ext 文件后缀，如：jpg、png
 * @param {*} num 遍历是数量
 * @param {*} label 子图的标签，但这里只能是所有子图的检测结果是一致的，动态的就需要手动配置
 * @returns
 */
export const getCommonImage = (
  commonPath,
  oriImgName,
  ext,
  num,
  label = ''
) => {
  const list = [
    {
      url: new URL(`${commonPath}/${oriImgName}.${ext}`, import.meta.url),
    },
  ]
  for (let i = 0; i < num; i++) {
    const item = {
      url: new URL(`${commonPath}/cut_${i}.${ext}`, import.meta.url),
    }
    label && (item.label = label)
    list.push(item)
  }
  return list
}
